/**
 * Engine API
 * Engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CampaignDto { 
    id?: number;
    tenant?: string;
    partner: string;
    dateStart: Date;
    dateEnd?: Date;
    code: string;
    name: string;
    description?: string;
    flux: CampaignDto.FluxEnum;
    type: CampaignDto.TypeEnum;
    source?: string;
    destination?: string;
    provider?: string;
    product: CampaignDto.ProductEnum;
    support: CampaignDto.SupportEnum;
    schedule: CampaignDto.ScheduleEnum;
    disable?: boolean;
    costInitial?: number;
    costUnitContact?: number;
    costUnitOrder?: number;
    transferMode?: string;
    scenario?: string;
    importEtl?: string;
    exportEtl?: string;
    dataType?: CampaignDto.DataTypeEnum;
    campaignMode: CampaignDto.CampaignModeEnum;
    objectiveUnits?: number;
    objectiveBudgetMax?: number;
    financialNote?: string;
    alertThresholdUnits?: number;
    alertThresholdCost?: number;
    alertEmailRecipients?: string;
    utmSource?: string;
    utmMedium?: string;
    utmCampaign?: string;
    utmTerm?: string;
    utmContent?: string;
    status: CampaignDto.StatusEnum;
    campaignGroupNames?: string[];
}
export namespace CampaignDto {
    export type FluxEnum = 'IMPORT' | 'EXPORT_SCENARIO' | 'EXPORT_DIRECT';
    export const FluxEnum = {
        IMPORT: 'IMPORT' as FluxEnum,
        EXPORTSCENARIO: 'EXPORT_SCENARIO' as FluxEnum,
        EXPORTDIRECT: 'EXPORT_DIRECT' as FluxEnum
    };
    export type TypeEnum = 'AFFILIATE' | 'NETWORK' | 'MEDIA';
    export const TypeEnum = {
        AFFILIATE: 'AFFILIATE' as TypeEnum,
        NETWORK: 'NETWORK' as TypeEnum,
        MEDIA: 'MEDIA' as TypeEnum
    };
    export type ProductEnum = 'FLIGHT' | 'HOTEL' | 'CAR' | 'PARKING' | 'ALL';
    export const ProductEnum = {
        FLIGHT: 'FLIGHT' as ProductEnum,
        HOTEL: 'HOTEL' as ProductEnum,
        CAR: 'CAR' as ProductEnum,
        PARKING: 'PARKING' as ProductEnum,
        ALL: 'ALL' as ProductEnum
    };
    export type SupportEnum = 'EMAILING' | 'SMS' | 'FILE' | 'FORM' | 'API' | 'MAIL';
    export const SupportEnum = {
        EMAILING: 'EMAILING' as SupportEnum,
        SMS: 'SMS' as SupportEnum,
        FILE: 'FILE' as SupportEnum,
        FORM: 'FORM' as SupportEnum,
        API: 'API' as SupportEnum,
        MAIL: 'MAIL' as SupportEnum
    };
    export type ScheduleEnum = 'DAILY' | 'HOURLY' | 'REAL_TIME' | 'MANUAL';
    export const ScheduleEnum = {
        DAILY: 'DAILY' as ScheduleEnum,
        HOURLY: 'HOURLY' as ScheduleEnum,
        REALTIME: 'REAL_TIME' as ScheduleEnum,
        MANUAL: 'MANUAL' as ScheduleEnum
    };
    export type DataTypeEnum = 'ORDERS' | 'CONTACTS';
    export const DataTypeEnum = {
        ORDERS: 'ORDERS' as DataTypeEnum,
        CONTACTS: 'CONTACTS' as DataTypeEnum
    };
    export type CampaignModeEnum = 'BUDGET_MAX' | 'UNITS_MAX' | 'SPREAD_EXPENSE';
    export const CampaignModeEnum = {
        BUDGETMAX: 'BUDGET_MAX' as CampaignModeEnum,
        UNITSMAX: 'UNITS_MAX' as CampaignModeEnum,
        SPREADEXPENSE: 'SPREAD_EXPENSE' as CampaignModeEnum
    };
    export type StatusEnum = 'DRAFT' | 'IN_PROGRESS' | 'SUSPENDED' | 'TERMINATED' | 'ARCHIVED' | 'DELETED';
    export const StatusEnum = {
        DRAFT: 'DRAFT' as StatusEnum,
        INPROGRESS: 'IN_PROGRESS' as StatusEnum,
        SUSPENDED: 'SUSPENDED' as StatusEnum,
        TERMINATED: 'TERMINATED' as StatusEnum,
        ARCHIVED: 'ARCHIVED' as StatusEnum,
        DELETED: 'DELETED' as StatusEnum
    };
}